<script setup lang="ts">
import { chapterList } from '~/constants/terms.const'
import { META } from '~/environment-variables/meta.const'
import { getBreadCrumb } from '~/utils/breadCrumbList'

useSeoMeta({
  title: 'Terms of Service',
  description: `View the ${META.siteName} Terms of Service`,
  get ogDescription () {
    return this.description
  },
  get twitterDescription () {
    return this.description
  }
})

useHead(getBreadCrumb())
</script>

<template>
  <div class="flex justify-center">
    <div class="content-cont">
      <div class="top-container">
        <span class="align-text-top text-2xl/[1.5rem] font-bold text-primary">Terms of Service</span>
        <br>
        <span class="text-base/[0.75rem] text-primary/40">Last updated: September 12, 2022</span>
      </div>
      <div>
        <ul>
          <li
            v-for="item in chapterList"
            :key="item.title"
          >
            <h2 class="mt-8 text-2xl/[2rem] font-bold text-primary">
              {{ item.title }}
            </h2>
            <ul>
              <li
                v-for="section in item.sections"
                :key="section.title"
              >
                <h3 class="mt-8 text-xl/[1.5rem] font-bold text-primary">
                  {{ section.title }}
                </h3>
                <template v-if="section.type === 'span'">
                  <p class="mt-2 text-lg/[1.25rem] text-primary/40">
                    {{ section.subItems[0].title }}
                  </p>
                </template>
                <template v-else-if="section.type === 'ul'">
                  <ul class="mt-2 text-lg/[1.25rem] text-primary/40">
                    <li
                      v-for="item in section.subItems"
                      :key="item.title"
                      class="ml-5 list-inside list-disc indent-[-1.25rem] text-lg/[1.25rem]"
                    >
                      {{ item.title }}
                      <template v-if="item.contents?.length > 0">
                        <ul class="mt-1 text-lg/[1.25rem] text-primary/40">
                          <li
                            v-for="content in item.contents"
                            :key="content"
                            class="ml-4 list-inside list-disc"
                          >
                            {{ content }}
                          </li>
                        </ul>
                      </template>
                    </li>
                  </ul>
                </template>
                <template v-else-if="section.type === 'ol'">
                  <ol class="mt-2 text-lg/[1.25rem] text-primary/40">
                    <li
                      v-for="item in section.subItems"
                      :key="item.title"
                      class="ml-5 list-inside list-decimal indent-[-1.25rem] text-lg/[1.25rem]"
                    >
                      {{ item.title }}
                      <template v-if="item.contents?.length > 0">
                        <ul class="mt-1 text-lg/[1.25rem] text-primary/40">
                          <li
                            v-for="content in item.contents"
                            :key="content"
                            class="ml-4 list-inside list-disc"
                          >
                            {{ content }}
                          </li>
                        </ul>
                      </template>
                    </li>
                  </ol>
                </template>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.content-cont {
  @apply w-[960px];
}

.top-container {
  @apply rounded-lg p-8 bg-gradient-to-l from-primary/[16%] to-point-color/40;
}
</style>